import React, { useState } from 'react';
import { Link } from "react-router-dom";
import axios from 'axios';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const apiUrl = process.env.REACT_APP_API_ENDPOINT;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!email) {
            setError('Email is required');
            return;
        }

        setIsLoading(true);
        try {
            await axios.post(`${apiUrl}/api/auth/forgot-password`, { email });
            setSuccess('Password reset link has been sent to your email. Please check your inbox.');
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to send reset link.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="page page-center" style={{ backgroundImage: "url('/assets/bg-signin-blue.png')", backgroundSize: 'cover', minHeight: '100vh' }}>
            <div className="container container-tight py-4">
                {/* <div className="text-center mb-4">
                    <Link to="/" className="navbar-brand p-0">
                        <img src="/static/idai_putih.jpg" height="20" alt="Logo" />
                    </Link>
                </div> */}

                <div className="card card-md">
                    <div className="card-body">
                        <h2 className="h2 text-center mb-4">Forgot Password</h2>
                        <p className="text-muted mb-4 text-center">
                            Enter your email address and we'll send you a link to reset your password.
                        </p>

                        {success ? (
                            <div className="alert alert-success text-center" role="alert">
                                {success}
                                <div className="mt-3">
                                    <Link to="/" className="btn btn-outline-primary">
                                        Back to Sign In
                                    </Link>
                                </div>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label">Email address</label>
                                    <input
                                        type="email"
                                        className={`form-control ${error ? 'is-invalid' : ''}`}
                                        placeholder="you@example.com"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    {error && <div className="invalid-feedback">{error}</div>}
                                </div>

                                <div className="form-footer">
                                    <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
                                        {isLoading ? 'Sending...' : 'Send Reset Link'}
                                    </button>
                                </div>

                                <div className="text-center text-muted mt-3">
                                    Remember your password? <Link to="/">Sign In</Link>
                                </div>
                            </form>
                        )}
                    </div>
                </div>

                <div className="text-center text-muted mt-3">
                    © {new Date().getFullYear()} IDAI-BANTEN
                </div>
            </div>

            {isLoading && (
                <div className="modal-backdrop fade show">
                    <div className="d-flex justify-content-center align-items-center vh-100">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <span className="ms-2 text-white">Processing...</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ForgotPassword;
